import script from "./FreeText.vue?vue&type=script&setup=true&lang=js"
export * from "./FreeText.vue?vue&type=script&setup=true&lang=js"

import "./FreeText.vue?vue&type=style&index=0&id=ead0ffd0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ead0ffd0"]])

export default __exports__